import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { Link } from 'react-router-dom'; 
import Layers from '@mui/icons-material/Layers';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  ListItemButton,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
} from '@mui/material';
import {
  Search,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  Engineering 
} from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

// Menu de navigation latéral avec icônes améliorées
const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];
const indicatorCards = [
  { title: "Population totale", value: "12 332 788", color: primaryColor },
  { title: "Ménages ordinaires", value: "12 220 934", color: secondaryColor },
  { title: "Population urbaine", value: "3 077 593", color: primaryColor },
  { title: "Population rurale", value: "9 255 195", color: secondaryColor }
];

const RGPHAEDataPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  
  // Données de la table
  const populationParTypeMenage = {
    title: "Effectif de la population résidente par type de ménage selon le milieu de résidence",
    data: [
      { type: "Ménage ordinaire", urbain: "2 990 465", rural: "9 230 469", total: "12 220 934" },
      { type: "Ménage collectif", urbain: "85 024", rural: "24 579", total: "109 603" },
      { type: "Sans abris", urbain: "2 104", rural: "147", total: "2 251" },
      { type: "Total", urbain: "3 077 593", rural: "9 255 195", total: "12 332 788" }
    ]
  };
  // Fonction pour gérer l'ouverture/fermeture du menu latéral sur mobile
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  // Filtrer les données selon le terme de recherche
  const filteredData = populationParTypeMenage.data.filter(row =>
    row.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}

            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h5" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {populationParTypeMenage.title}
                    </Typography>
                  </Box>
                   <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                     <Grid item xs={12} sm={6} md={6} ></Grid>
                      <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      size="small"
                      placeholder="Rechercher..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                   </Grid>
                   </Grid>
                  {/* Section des indicateurs clés - Version avec Accordion */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés de la Population du Burundi
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        {indicatorCards.map((item, index) => (
                          <Grid item xs={12} sm={6} md={3} key={index}>
                            <Card sx={{ 
                              height: '100%', 
                              borderLeft: `4px solid ${item.color}`,
                              backgroundColor: item.color,
                              color: 'white',
                              transition: 'transform 0.3s',
                              '&:hover': { transform: 'scale(1.03)' }
                            }}>
                              <CardContent sx={{ textAlign: 'center' }}>
                                <Typography variant="subtitle2">{item.title}</Typography>
                                <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold">
                                  {item.value}
                                </Typography>
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Population par type de ménage</TableCell>
                          <TableCell align="right">Milieu urbain</TableCell>
                          <TableCell align="right">Milieu rural</TableCell>
                          <TableCell align="right">Total</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.map((row, index) => (
                          <TableRow 
                            key={index} 
                            hover
                            sx={{ 
                              '&:last-child td, &:last-child th': { border: 0 },
                              backgroundColor: row.type === 'Total' ? '#f0f0f0' : 'inherit',
                              fontWeight: row.type === 'Total' ? 'bold' : 'normal'
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {row.type}
                            </TableCell>
                            <TableCell align="right">{row.urbain}</TableCell>
                            <TableCell align="right">{row.rural}</TableCell>
                            <TableCell align="right">{row.total}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
                
                {/* Notes méthodologiques */}
               <Paper sx={{ 
  p: 2, 
  backgroundColor: '#f0f0f0', 
  borderLeft: `4px solid ${secondaryColor}`,
  marginTop: 2
}}>
  <Typography variant="subtitle2" gutterBottom color="primary" fontWeight="bold">
    Notes méthodologiques
  </Typography>
  
  <Accordion defaultExpanded elevation={0} sx={{ backgroundColor: 'transparent' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="body2" fontWeight="bold" color="text.secondary">
        Source des données
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography variant="body2" color="text.secondary">
        Recensement Général de la Population, de l'Habitat, de l'Agriculture et de l'Élevage (RGPHAE 2024).
      </Typography>
    </AccordionDetails>
  </Accordion>

  <Accordion elevation={0} sx={{ backgroundColor: 'transparent' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="body2" fontWeight="bold" color="text.secondary">
        Définitions clés
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <List dense sx={{ pl: 2, listStyleType: 'disc' }} component="ul">
        <ListItem sx={{ display: 'list-item' }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Ménage ordinaire :</strong> Groupe de personnes vivant ensemble et partageant habituellement 
            leur repas (peut comprendre une seule personne).
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item' }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Ménage collectif :</strong> Ensemble de personnes vivant dans des institutions 
            (casernes, prisons, internats, hôpitaux, etc.) sans lien familial.
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item' }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Sans-abri :</strong> Personnes sans domicile fixe recensées dans des lieux publics 
            ou des centres d'hébergement temporaire.
          </Typography>
        </ListItem>
      </List>
    </AccordionDetails>
  </Accordion>
  <Accordion elevation={0} sx={{ backgroundColor: 'transparent' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="body2" fontWeight="bold" color="text.secondary">
        Couverture géographique
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography variant="body2" color="text.secondary">
        L'ensemble du territoire national, avec distinction urbain/rural selon la classification administrative officielle.
      </Typography>
    </AccordionDetails>
  </Accordion>

  <Accordion elevation={0} sx={{ backgroundColor: 'transparent' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="body2" fontWeight="bold" color="text.secondary">
        Méthode de collecte
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography variant="body2" color="text.secondary">
        Dénombrement exhaustif avec questionnaire individuel, vérification par échantillonnage a posteriori (5% des zones contrôlées).
      </Typography>
    </AccordionDetails>
  </Accordion>

  <Accordion elevation={0} sx={{ backgroundColor: 'transparent' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="body2" fontWeight="bold" color="text.secondary">
        Exclusions
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <List dense sx={{ pl: 2, listStyleType: 'disc' }} component="ul">
        <ListItem sx={{ display: 'list-item' }}>
          <Typography variant="body2" color="text.secondary">
            Personnel diplomatique étranger en poste au Burundi
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item' }}>
          <Typography variant="body2" color="text.secondary">
            Personnes en transit dans le pays au moment du recensement
          </Typography>
        </ListItem>
      </List>
    </AccordionDetails>
  </Accordion>

  <Accordion elevation={0} sx={{ backgroundColor: 'transparent' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="body2" fontWeight="bold" color="text.secondary">
        Précision des données
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography variant="body2" color="text.secondary">
        Les totaux peuvent différer légèrement de la somme des composantes en raison des règles d'arrondi appliquées (à la centaine près pour les chiffres supérieurs à 10 000).
      </Typography>
    </AccordionDetails>
  </Accordion>
</Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer>
  );
};

export default RGPHAEDataPage;